module.exports = __webpack_public_path__ + "img/MoonSword 3b.5fa90354.png";